import React from 'react';
import { useField } from 'formik';
import { Select } from '@guildeducationinc/recess';
import { PROGRAM_TYPES } from '@src/constants';

export interface ProgramTypeSelectFieldProps {
  label: string;
  name: string;
}

const ProgramTypeSelectField: React.FC<ProgramTypeSelectFieldProps> = ({ label, name }) => {
  const [field, meta] = useField({ name });

  return (
    <Select
      {...field}
      errors={meta.touched && meta.error ? meta.error : undefined}
      isClearable={false}
      isInvalid={!!meta.error && meta.touched}
      isSearchable={true}
      label={label}
      name={name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      options={PROGRAM_TYPES}
      required={true}
      value={field.value}
      setValue={(options, value) => {
        return options.filter((option) => option.value === value) || {};
      }}
    />
  );
};

export default ProgramTypeSelectField;
